<template>
    <v-container class="ufv-container-pages d-flex flex-column pt-0">
        <div class="ufv-container-text">
            <div class="text-h4">Buscar Chamados</div>
        </div>
        <div class="my-6 flex-grow-1" style="border: 0px solid red">
            <div class="d-flex justify-space-between align-center">
                <v-text-field
                    style="border: 0px solid green"
                    append-icon="mdi-magnify"
                    dense
                    hide-details
                    placeholder="Procurar Chamado"
                    class="ml-0 flex-grow-1"
                    filled
                    v-model="filtro"
                >
                </v-text-field>
            </div>
            <div class="chamados d-flex flex-row justify-center">
                <div
                    v-if="loading"
                    class="ufv-menu-loading my-8 align-self-stretch d-flex align-center"
                >
                    <spinner />
                </div>
                <div v-if="!loading" class="my-6 flex-grow-1">
                    <list-chamados
                        v-if="chamados.length > 0"
                        :chamados="chamados"
                    />
                </div>
            </div>
        </div>
        <div class="mt-8">
            <v-pagination
                :value="pagina"
                :length="numPaginas"
                :total-visible="7"
                @input="mudarPagina"
            />
        </div>
    </v-container>
</template>

<style scoped>
.chamados {
    min-height: 400px;
}
</style>

<script>
import debounce from "lodash/debounce";
import { mapGetters } from "vuex";
import ListChamados from "../../componentes/chamados/ListChamados.vue";
import Spinner from "../../componentes/ui/Spinner.vue";
import RequestCancelled from "../../api/RequestCancelled";

export default {
    data() {
        return {
            filtro: "",
            chamados: [],
            loading: false,
            pagina: 1,
            itensPorPagina: 10,
            totalItens: 0,
        };
    },
    components: {
        ListChamados,
        Spinner,
    },
    mounted() {
        this.pagina = this.$route.query.pagina
            ? parseInt(this.$route.query.pagina)
            : 1;
        this.itensPorPagina = this.$route.query.itensporpagina
            ? parseInt(this.$route.query.itensporpagina)
            : 10;
        this.filtro = this.$route.query.filtro || "";
        this.atualizarChamados();
    },
    methods: {
        mudarPagina(novaPagina) {
            if (novaPagina !== this.pagina) {
                this.$router.push({
                    name: "BuscarChamados",
                    query: {
                        pagina: novaPagina,
                        itensporpagina: this.itensPorPagina,
                        filtro: this.filtro,
                        offset: (novaPagina - 1) * this.itensPorPagina,
                    },
                });
            }
        },
        atualizarChamados() {
            this.loading = true;
            if (this.filtro.length > 0) {
                this.$servicoChamados
                    .buscarChamados({
                        idUsuario: this.identidadeEfetiva.id,
                        contextoId: this.contexto.id,
                        offset: this.offset,
                        limit: this.itensPorPagina,
                        texto: this.filtro,
                    })
                    .then((resposta) => {
                        this.totalItens = resposta.maxSize;
                        return resposta.items;
                    })
                    .then((chamados) => {
                        this.chamados = chamados;
                        this.loading = false;
                    })
                    .catch((err) => {
                        if (err instanceof RequestCancelled) {
                            return;
                        }
                        console.log(err);
                        this.$router.push({ name: "500" });
                    });
            } else {
                this.chamados = [];
                this.totalItens = 0;
                this.loading = false;
            }
        },
        buscarChamado() {
            this.$router.push({
                name: "BuscarChamados",
                query: {
                    pagina: 1,
                    itensporpagina: this.itensPorPagina,
                    filtro: this.filtro,
                    offset: 0,
                },
            });
        },
    },
    computed: {
        ...mapGetters("autenticacao", ["identidadeEfetiva"]),
        ...mapGetters("contexto", ["contexto"]),
        offset: function () {
            const result = (this.pagina - 1) * this.itensPorPagina;

            if (isNaN(result) || result < 0) {
                return 0;
            }

            return result;
        },
        numPaginas: function () {
            return Math.ceil(this.totalItens / this.itensPorPagina);
        },
    },
    watch: {
        filtro: debounce(function () {
            this.buscarChamado();
        }, 500),
        "$route.query": {
            handler() {
                this.pagina = this.$route.query.pagina
                    ? parseInt(this.$route.query.pagina)
                    : 1;
                this.itensPorPagina = this.$route.query.itensporpagina
                    ? parseInt(this.$route.query.itensporpagina)
                    : 10;
                this.filtro = this.$route.query.filtro || "";
                this.atualizarChamados();
            },
            immediate: true,
        },
        contexto(novo, antigo) {
            if (novo.id !== antigo.id) {
                this.$router.push({
                    name: "BuscarChamados",
                    query: {
                        pagina: 1,
                        itensporpagina: this.itensPorPagina,
                        filtro: this.filtro,
                        offset: this.itensPorPagina,
                    },
                });

                this.pagina = 1;
                this.atualizarChamados();
            }
        },
        "identidadeEfetiva.id"(novo, antigo) {
            if (novo !== antigo) {
                this.$router.push({
                    name: "BuscarChamados",
                    query: {
                        pagina: 1,
                        itensporpagina: this.itensPorPagina,
                        filtro: this.filtro,
                        offset: this.itensPorPagina,
                    },
                });

                this.pagina = 1;
                this.atualizarChamados();
            }
        },
    },
};
</script>
